import { render, staticRenderFns } from "./TrainingDetailsModule.vue?vue&type=template&id=4529a314&scoped=true"
import script from "./TrainingDetailsModule.vue?vue&type=script&lang=js"
export * from "./TrainingDetailsModule.vue?vue&type=script&lang=js"
import style0 from "./TrainingDetailsModule.vue?vue&type=style&index=0&id=4529a314&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4529a314",
  null
  
)

export default component.exports